<template src="./bulk-delete-keywords.component.html"></template>
<style scoped src="./bulk-delete-keywords.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import Sidebar from '@/components/sidebar/sidebar.component.vue';
import api from '@/api';
import {toasted} from '@/plugins/toasted';
import {getErrorMessage, isFalsy, splitKeywords} from '@/helpers';
import {Market} from '@/models';

export default Vue.extend({
  components: {
    Sidebar,
  },
  data() {
    return {
      form: {
        keywords: '',
        markets: [] as string[],
        column: 'id',
      },
      options: {
        markets: [] as string[],
      },
    };
  },
  computed: {
    keywordRows() {
      const value = this.form.keywords ?? '';
      const min = 5;
      const max = 10;
      return Math.min(Math.max(value.split('\n').length || 1, min), max);
    },
    isFormValid() {
      return !isFalsy(this.form.keywords) && (this.form.column === 'id' || this.form.column === 'keyword');
    },
  },
  async created() {
    await Promise.all([
      this.getMarkets(),
    ]);
  },
  mounted() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  destroyed() {
    document.body.classList.remove(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  methods: {
    async getMarkets() {
      const markets = await api.execute('get', '/markets') as Market[];
      this.options.markets = markets.map(el => el.code);
    },
    async onSubmit() {
      const data = this.form.column === 'id'
        ? {ids: splitKeywords(this.form.keywords)}
        : {keywords: splitKeywords(this.form.keywords), markets: this.form.markets};
      try {
        await api.execute('post', '/campaigns-archive/delete', data);
        this.resetForm();
        toasted.showSuccessMessage('Keywords deleted');
      } catch (e) {
        console.error(e);
        toasted.showErrorMessage(getErrorMessage(e));
      }
    },
    resetForm() {
      this.form.keywords = '';
      this.form.markets = [];
      this.form.column = 'id';
    },
  },
});
</script>
